'use client'

import { makeOriginUrl } from '@polaris/core/utils'
import {
  ConnectionProvider,
  WalletProvider as SolanaWalletProvider,
} from '@solana/wallet-adapter-react'
import type { PropsWithChildren } from 'react'

export function SolanaProvider({ children }: PropsWithChildren) {
  return (
    <ConnectionProvider
      endpoint={makeOriginUrl(
        '/api/chains/proxy?chainId=solana:mainnet-beta',
      ).toString()}
    >
      <SolanaWalletProvider wallets={[]} autoConnect>
        {children}
      </SolanaWalletProvider>
    </ConnectionProvider>
  )
}
